import React from "react";

// CSS
import "../../css/sections/yellow-bar.css";

class YellowBar extends React.PureComponent {
	render() {
		return <div className="yellow-bar">{this.props.children}</div>;
	}
}

export default YellowBar;



// WEBPACK FOOTER //
// ./src/components/utils/YellowBar.js